import { Component, Input } from '@angular/core';
import { SbDateTime, SbLocalDateTime } from '../../services/api/api-date-time';

@Component({
  selector: 'sb-comp-validity-range-display',
  templateUrl: './validity-range-display.component.html',
  styleUrls: ['./validity-range-display.component.scss'],
  standalone: false,
})
export class ValidityRangeDisplayComponent {
  @Input() from: SbDateTime | SbLocalDateTime | null = null;
  @Input() till: SbDateTime | SbLocalDateTime | null = null;
}
